import LoginService from "./LoginService";

/**
 * Returns the headers required to authenticate against the backend.
 */
export const getHeaders = (): { headers: Record<string, string> } => {
    return {
        headers: {
            Authorization: `Bearer ${LoginService.getToken()}`
        }
    };
};

/**
 * gRPC equivalent to headers
 * Returns the metadata required to authenticate against the backend.
 */
export const getMetadata = (): { metadata: Record<string, string> } => {
    return {
        metadata: {
            Authorization: `Bearer ${LoginService.getToken()}`
        }
    };
};
